class AIChatCarousel extends HTMLElement {
  constructor () {
    super()
    this.attachShadow({ mode: 'open' })
    this._images = [
      'https://picsum.photos/id/10/800/600',
      'https://picsum.photos/id/20/800/600'
    ]
  }
 
  connectedCallback () {
    this.render()
  }
 
  static get observedAttributes () { return ['images'] }
 
  attributeChangedCallback (name, oldVal, newVal) {
    if (name === 'images' && newVal) {
      try {
        this._images = JSON.parse(newVal)
        this.render()
      } catch (e) { console.error(e) }
    }
  }
 
  openModal (src) {
    const modal = this.shadowRoot.getElementById('modal')
    const modalImg = this.shadowRoot.getElementById('modalImg')
    modalImg.src = src
    modal.classList.add('active')
  }
 
  closeModal () {
    this.shadowRoot.getElementById('modal').classList.remove('active')
  }
 
  render () {
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; width: 100%; margin: 8px 0; font-family: sans-serif; }
        .wrapper { position: relative; width: 100%; }
       
        .track {
          display: flex; gap: 8px; overflow-x: auto;
          scroll-snap-type: x mandatory; scrollbar-width: none; padding: 4px 0;
        }
        .track::-webkit-scrollbar { display: none; }
 
        .item {
          flex: 0 0 calc(45% - 8px); min-width: 150px;
          scroll-snap-align: start; cursor: zoom-in;
        }
 
        img {
          width: 100%; height: 140px; object-fit: cover;
          border-radius: 10px; display: block; background: #333;
          transition: transform 0.2s ease;
        }
        img:hover { transform: scale(1.02); }
 
        /* Modal / Zoom Styles */
        .modal {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(0, 0, 0, 0.9); z-index: 1000;
          display: flex; align-items: center; justify-content: center;
          opacity: 0; pointer-events: none; transition: opacity 0.3s ease;
        }
        .modal.active { opacity: 1; pointer-events: auto; }
       
        .modal img {
          width: auto; height: auto; max-width: 90%; max-height: 90%;
          object-fit: contain; border-radius: 4px; box-shadow: 0 0 20px rgba(0,0,0,0.5);
          transform: scale(0.9); transition: transform 0.3s ease;
        }
        .modal.active img { transform: scale(1); }
 
        .close-btn {
          position: absolute; top: 20px; right: 20px;
          color: white; font-size: 30px; cursor: pointer;
          background: rgba(255,255,255,0.1); width: 40px; height: 40px;
          border-radius: 50%; display: flex; align-items: center; justify-content: center;
        }
 
        /* Nav Buttons */
        .nav-btn {
          position: absolute; top: 50%; transform: translateY(-50%);
          width: 28px; height: 28px; border-radius: 50%;
          background: rgba(0, 0, 0, 0.7); border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          z-index: 5; opacity: 0; transition: opacity 0.2s;
        }
        .wrapper:hover .nav-btn { opacity: 1; }
        .prev { left: 4px; } .next { right: 4px; }
        svg { width: 16px; height: 16px; fill: none; stroke: white; stroke-width: 3; }
      </style>
 
      <div class="wrapper">
        <button class="nav-btn prev" id="prevBtn" style="display:none">
          <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
       
        <div class="track" id="track">
          ${this._images.map(src => `
            <div class="item">
              <img src="${src}" class="gallery-img">
            </div>
          `).join('')}
        </div>
 
        <button class="nav-btn next" id="nextBtn">
          <svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      </div>
 
      <div class="modal" id="modal">
        <span class="close-btn" id="closeBtn">&times;</span>
        <img id="modalImg" src="">
      </div>
    `
 
    // Lógica de Zoom
    this.shadowRoot.querySelectorAll('.gallery-img').forEach(img => {
      img.onclick = () => this.openModal(img.src)
    })
 
    this.shadowRoot.getElementById('modal').onclick = () => this.closeModal()
    this.shadowRoot.getElementById('closeBtn').onclick = () => this.closeModal()
 
    // Lógica de Scroll
    const track = this.shadowRoot.getElementById('track')
    const nextBtn = this.shadowRoot.getElementById('nextBtn')
    const prevBtn = this.shadowRoot.getElementById('prevBtn')
 
    nextBtn.onclick = (e) => {
      e.stopPropagation()
      track.scrollBy({ left: track.clientWidth * 0.7, behavior: 'smooth' })
    }
    prevBtn.onclick = (e) => {
      e.stopPropagation()
      track.scrollBy({ left: -track.clientWidth * 0.7, behavior: 'smooth' })
    }
 
    track.onscroll = () => {
      prevBtn.style.display = track.scrollLeft > 10 ? 'flex' : 'none'
      const isEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 10
      nextBtn.style.display = isEnd ? 'none' : 'flex'
    }
  }
}
 
customElements.define('ai-carousel', AIChatCarousel)
